import {
  TemplateParentTypeEnum,
  WidgetTypeConfig,
} from '@/types';
// V3
// eslint-disable-next-line import/no-cycle
import displayWidgetSmartProductListConfig from '@/components/template-builder/config/templates/display/widgets/widget-smart-product-list-fields-config';
// eslint-disable-next-line import/no-cycle
import emailWidgetSmartProductListConfig from '@/components/template-builder/config/templates/email/widgets/widget-smart-product-list-fields-config';
// eslint-disable-next-line import/no-cycle
import facebookMessengerWidgetSmartProductListConfig from '@/components/template-builder/config/templates/facebookmessenger/widgets/widget-smart-product-list-fields-config';
// V4
// eslint-disable-next-line import/no-cycle
import displayWidgetSmartProductListConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-smart-product-list-fields-config';
// eslint-disable-next-line import/no-cycle
import emailWidgetSmartProductListConfigV4 from '@/components/template-builder/config/templates/email-v4/widgets/widget-smart-product-list-fields-config';

const smartProductListConfigV3 = {
  [TemplateParentTypeEnum.POPUP]: displayWidgetSmartProductListConfig,
  [TemplateParentTypeEnum.EMBED]: displayWidgetSmartProductListConfig,
  [TemplateParentTypeEnum.EMAIL]: emailWidgetSmartProductListConfig,
  [TemplateParentTypeEnum.FACEBOOKMESSENGER]: facebookMessengerWidgetSmartProductListConfig,
};

const smartProductListConfigV4 = {
  [TemplateParentTypeEnum.POPUP]: displayWidgetSmartProductListConfigV4,
  [TemplateParentTypeEnum.EMBED]: displayWidgetSmartProductListConfigV4,
  [TemplateParentTypeEnum.EMAIL]: emailWidgetSmartProductListConfigV4,
  [TemplateParentTypeEnum.FACEBOOKMESSENGER]: facebookMessengerWidgetSmartProductListConfig,
};

const getWidgetSmartProductListConfig = (templateType: string, isV4 = false): WidgetTypeConfig => {
  const config = isV4 ? smartProductListConfigV4 : smartProductListConfigV3;
  if (
    templateType === TemplateParentTypeEnum.POPUP
    || templateType === TemplateParentTypeEnum.EMBED
    || templateType === TemplateParentTypeEnum.EMAIL
    || templateType === TemplateParentTypeEnum.FACEBOOKMESSENGER
  ) {
    return config[templateType];
  }
  return {};
};

export default getWidgetSmartProductListConfig;
